export default "__VITE_ASSET__DmTlJbcw__"